import { format } from 'date-fns';

export const formatDateShort = (date: Date) => format(date, 'd LLL yyyy');
